export default __webpack_public_path__ + "static/media/contentful_logo.3d6ddcb8.png";